// Serializes the builder's in-memory state (including unsaved edits) into a
// compact snapshot sent to the Remix AI builder agent. Style-only noise is
// kept to a minimum by whitelisting keys per object type.

const SNAPSHOT_KEYS = {
  steps: ["id", "position", "options"],
  sections: [
    "id",
    "step_id",
    "element_id",
    "content_toggle_item_id",
    "position",
    "options",
  ],
  section_columns: ["id", "section_id", "position"],
  elements: [
    "id",
    "section_id",
    "section_column_id",
    "step_id",
    "position",
    "column",
    "element_type",
    "html",
    "options",
  ],
  fields: [
    "id",
    "element_id",
    "field_id",
    "label",
    "placeholder",
    "slug",
    "position",
    "required",
    "field_type",
    "options",
  ],
  field_options: [
    "id",
    "field_id",
    "label",
    "value",
    "position",
    "option_type",
    "emoji",
    "letter",
    "icon",
    "score",
    "color",
    "image",
    "jump_field_id",
  ],
  content_list_items: [
    "id",
    "element_id",
    "content",
    "position",
    "visual_type",
    "icon",
    "letter",
    "emoji",
    "image",
    "options",
  ],
  content_toggle_items: ["id", "element_id", "content", "position", "options"],
  action_groups: ["id", "element_id", "step_id", "field_id", "data"],
  actions: [
    "id",
    "contactable_type",
    "contactable_id",
    "action_type",
    "tag_id",
    "cta_id",
    "integration_id",
    "recipients",
    "data_name",
    "data",
  ],
  conditions: [
    "id",
    "contactable_type",
    "contactable_id",
    "condition_type",
    "keyword",
    "operator",
    "url",
    "count",
    "data_name",
    "country",
    "data",
  ],
  products: [
    "id",
    "element_id",
    "product_recommendation_id",
    "title",
    "price",
    "discounted_price",
    "image",
    "description",
    "redirect_url",
    "position",
  ],
  product_variants: [
    "id",
    "product_id",
    "title",
    "price",
    "image",
    "position",
    "redirect_url",
    "discounted_price",
    "description",
  ],
  product_recommendations: ["id", "element_id", "options"],
  review_recommendations: ["id", "element_id", "options"],
  scheduler_recommendations: ["id", "element_id", "options"],
  embed_recommendations: ["id", "element_id", "options"],
};

function pickKeys(object, keys) {
  const picked = {};

  keys.forEach((key) => {
    const value = object[key];
    if (value !== undefined && value !== null) {
      picked[key] = value;
    }
  });

  return picked;
}

export default function serializeBuilderSnapshot(contextData) {
  const variant = contextData.objects.variant;
  const cta = contextData.objects.cta || {};

  const snapshot = {
    cta: { id: cta.id, cta_type: cta.cta_type },
    variant: { id: variant.id, options: variant.options || {} },
  };

  Object.keys(SNAPSHOT_KEYS).forEach((object_type) => {
    const collection = variant[object_type] || {};
    const serialized = {};

    Object.values(collection).forEach((object) => {
      if (!object || object.toBeDeleted === true) return;

      serialized[object.id] = pickKeys(object, SNAPSHOT_KEYS[object_type]);
    });

    snapshot[object_type] = serialized;
  });

  return snapshot;
}
